import { AnimatedMessaging } from 'signup-components/styles/MessagingAnimations.styles';
import { useOnImageLoaded } from '../images/useOnImageLoaded';
import { BaseMessageCaption } from './BaseMessageCaption';
import { getMessage } from './MESSAGE';
import { StyledIllustration, StyledMessagingIllustration } from './Messaging.styles';
import { isTransitionAndAnimationsDisabled } from '../selenium/seleniumFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
const MessageIllustration = ({
  messageKey
}) => {
  const {
    illustrationName,
    height
  } = getMessage(messageKey);
  const {
    imageLoaded,
    handleImageLoaded
  } = useOnImageLoaded(illustrationName);
  return /*#__PURE__*/_jsx(AnimatedMessaging, {
    disable: isTransitionAndAnimationsDisabled(),
    loaded: imageLoaded,
    children: /*#__PURE__*/_jsx(StyledIllustration, {
      children: /*#__PURE__*/_jsx(BaseMessageCaption, {
        messageKey: messageKey,
        children: /*#__PURE__*/_jsx(StyledMessagingIllustration, {
          height: height,
          name: illustrationName,
          onLoad: handleImageLoaded
        })
      })
    })
  });
};
export default MessageIllustration;